<script>
export default {
  name: 'WithTheMenu',
}
</script>


<template>
    <div id="app">
        <nav>
            <div class="header">
                <div class="header__avatar"></div>
                <div class="header__text">
                <div class="header__text__username">Adrien DELAUNAY</div>
                <div class="header__text__agencename">Agence VDA</div>
                </div>
            </div>

            <div class="links">
                <router-link class="links__routerLink" to="/"><MenuItem text="Accueil"/></router-link>
                <router-link class="links__routerLink" to="/projets"><MenuItem text="Projets"/></router-link>
                <router-link class="links__routerLink" to="/login"><MenuItem text="Connexion"/></router-link>
            </div>
        </nav>
        <!-- <router-view id="main-view"></router-view> -->
        <slot />

        <!-- <div v-bind:key='item' v-for="item in info">
        <a v-bind:href="item._id"><h1>{{item.title}}</h1></a>
        <p>{{item.description}}</p>
        </div>
        <input id="textTitle" type="text"><input id="textDescription" type="text">
        <button @click="postIt()">Cliquez ici !</button> -->
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @import '../assets/main.scss';

// #app{
//     display: flex;
// }

// nav{
//     border: red solid 1px;
// }

// #main-view{
//     border: blue solid 1px;
// }

// nav{
  // background-color: $mainColor;
  // background-image: url('../assets/menuBackground.png');
//   background-color: red;
//   border-radius: 10px;
//   margin-left: -10px; //pour échapper le border-radius
//   padding-left: 10px; //pour qu'il n'y ai rien dans ces 10px hors fenêtre
//   min-height: 100vh;
//   width: 300px
// }

// .header{
//   margin: 25px 0 60px 25px;
//   display: flex;

//   &__avatar{
//     height: 50px;
//     width: 50px;
//     border-radius: 50px;
//     background: rgb(44,51,64);
//     background: linear-gradient(135deg, rgba(44,51,64,1) 0%, rgba(15,98,129,1) 20%, rgba(240,216,158,1) 66%, rgba(254,225,76,1) 100%);
//     margin-right: 10px;
//   }

//   &__text{
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     color: $menuTextColor;
//     @include myFont();

//     &__username{
//       font-size: 18px;
//       font-weight: 700;
//     }
//   }
// }

// .links{
//   margin: 0 0 0 25px;

//   &__routerLink{
//     text-decoration: none;
//     color: $menuTextColor;
//     &:visited{
//       color: $menuTextColor;
//     }
//   }
// }

// #main-view{
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     flex: 1;
//     background-color: red;
//     border: blue solid 15px;
// }


</style>
